import { createUrl } from "@/redux/api";
import {
  AcceptApplicationRequest,
  ApplicationQueryParams,
  ApplicationResponse,
  RejectApplicationRequest,
  SubmitApplicationRequest,
  Tags,
  TagsType,
  VerifyApplicationRequest,
} from "@/redux/applications/types";
import { isPaginatedResponse } from "@/redux/typeGuards";
import { BuilderType, PaginatedResponse } from "@/redux/types";

const applicationsService = (builder: BuilderType<Tags>) => ({
  getApplications: builder.query<
    ApplicationResponse[] | PaginatedResponse<ApplicationResponse>,
    ApplicationQueryParams
  >({
    query: (filters) => ({
      url: createUrl("/applications/", filters),
      method: "GET",
    }),
    providesTags: (result): TagsType[] =>
      result
        ? [
            ...(
              (isPaginatedResponse(result)
                ? result.results
                : result) as ApplicationResponse[]
            ).map(
              (i): TagsType => ({
                type: "Application",
                id: i.id,
              }),
            ),
            { type: "Applications" },
          ]
        : [],
  }),
  submitApplication: builder.mutation<
    ApplicationResponse,
    SubmitApplicationRequest
  >({
    query: (data) => ({
      url: "/applications/submit/",
      method: "POST",
      data,
    }),
  }),
  verifyApplication: builder.mutation<
    ApplicationResponse,
    VerifyApplicationRequest
  >({
    query: (data) => ({
      url: "/applications/verify/",
      method: "POST",
      data,
    }),
  }),
  acceptApplicationById: builder.mutation<
    ApplicationResponse,
    { id: number; data: AcceptApplicationRequest }
  >({
    query: ({ id, data }) => ({
      url: `/applications/${id}/accept/`,
      method: "POST",
      data,
    }),
    invalidatesTags: (result): TagsType[] =>
      result
        ? [{ type: "Application", id: result.id }, { type: "Applications" }]
        : [],
  }),
  rejectApplicationById: builder.mutation<
    ApplicationResponse,
    { id: number; data: RejectApplicationRequest }
  >({
    query: ({ id, data }) => ({
      url: `/applications/${id}/reject/`,
      method: "POST",
      data,
    }),
    invalidatesTags: (result): TagsType[] =>
      result
        ? [{ type: "Application", id: result.id }, { type: "Applications" }]
        : [],
  }),
});

export default applicationsService;
